import React from 'react';
import Avatar from '../Avatar';
import Text from '../Text';
import * as Styles from './styles';
import { useGetLoginInfo } from '../Header/services/useGetLoginInfo';
const StaticUserProfile = _ref => {
  let {
    teamKey
  } = _ref;
  const {
    profilePicture,
    userName
  } = useGetLoginInfo({
    teamKey
  });
  if (!userName) return null;
  return React.createElement(Styles.StaticUserProfileContainer, {
    "data-testid": "static-user-profile"
  }, React.createElement(Avatar, {
    size: "32px",
    className: "static-profile-avatar",
    src: profilePicture
  }), React.createElement(Text.BodySmall, {
    weight: "semibold",
    className: "focus-header-username"
  }, userName.split(' ')[0]));
};
export default StaticUserProfile;